module.exports = __webpack_public_path__ + "img/22.b8a3df1f.png";